module.exports = {
  "dof-city": {
    "position": "fixed",
    "width": "750",
    "backgroundColor": "#F2F3F4"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-743fe044!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-city/index.vue
// module id = 517
// module chunks = 0 1